import React, { useEffect, useState } from 'react'

interface QuestionProps {
  title? : string
  name? : string	
  options?: { id: string, title: string, value: string | boolean }[]
  children?: React.ReactNode
  defaultValue?: string | boolean | null // Initial state could be empty string
  onChange?: (value: string) => void
  style?: string
  error?: {
    message?: string // Allow message to be undefined
  }
}

const Question: React.FC<QuestionProps> = ({ title, name, options = [], error, defaultValue, style = 'heading', onChange }) => {
  const [selectedValue, setSelectedValue] = useState<string | boolean | null>(defaultValue ?? null)

  useEffect(() => {
    setSelectedValue(defaultValue ?? null)
    if (defaultValue !== undefined && defaultValue !== null && onChange) {
      onChange(defaultValue as string)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValue])

  return (
    <fieldset className={`${style === 'heading' ? 'pt-3 pb-10' : '' } last:pb-0`}>
      <p className={`${style === 'heading' ? 'text-center max-w-4xl mx-auto text-2xl md:text-3xl text-pretty' : 'block pl-2.5 text-sm/6 font-[var(--font-weight-bold)] h-6 leading-4 text-pretty' } ${error ? 'text-[var(--theme-danger)]' : 'text-[var(--theme-text)]'}`}>{title}</p>
      <div className={`flex items-center gap-10 ${style === 'heading' ? 'justify-center mt-1' : 'pl-2.5 mt-2.5' }`}>
        {options.map((option) => (
          <div key={option.id} className='h-[50px] flex items-center'>
            <input
              id={option.id}
              name={name}
              type='radio'
              value={option.value as string}
              checked={selectedValue === option.value}
              onChange={() => {
                setSelectedValue(option.value)
                onChange && onChange(option.value as string)
              }}
              className={`
                relative size-7 sm:size-8 shrink-0 appearance-none cursor-pointer rounded-full border border-[var(--radio-border)] bg-white
                before:absolute checked:before:inset-1.5 sm:checked:before:inset-2 before:inset-[9px] sm:before:inset-[11px] before:rounded-full checked:before:bg-[var(--radio-active-bg)] before:bg-[var(--radio-inactive-bg)] checked:bg-white 
                focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--input-text)]
                disabled:border-gray-300 disabled:bg-gray-100 disabled:before:bg-gray-400 forced-colors:appearance-auto forced-colors:before:hidden
              `}
            />
            <label htmlFor={option.id} className={`${style === 'heading' ? 'font-[var(--font-weight-bold)] text-sm sm:text-base' : '' } pl-3.5 block text-base cursor-pointer`}>
              {option.title}
            </label>
          </div>
        ))}
      </div>
      {error && error.message && <p className={`p-0.5 pt-3 text-md text-[var(--theme-danger)] ${style === 'heading' ? 'text-center pt-3' : 'pl-2.5 pt-[2px]' }`}>{error.message}</p>}
    </fieldset>
  )
}

export {Question}